export default __webpack_public_path__ + "images/28_1_image.jpg";